import { useEffect, useState } from 'react'
import { TASK_NOUN } from '../lib/status'
import { endQueue, moveQueue, queueHere, readQueue } from '../lib/workQueue'
import '../styles/work-queue.css'

// The one line a task's screen shows when it was opened from My work: where it
// stands in the list, the tasks either side, and the way back to the list
// (lib/workQueue.ts says why). Drawn by the shell above every screen, so no
// screen needs to know about it; it draws nothing where the address is not one
// of the queue's tasks.
export function WorkQueueBar({ subject }: { subject: string }) {
  const [hash, setHash] = useState(() => window.location.hash)
  useEffect(() => {
    const sync = () => setHash(window.location.hash)
    window.addEventListener('hashchange', sync)
    return () => window.removeEventListener('hashchange', sync)
  }, [])
  const [, setEnded] = useState(0)

  const here = queueHere(readQueue(), hash, subject)
  // The page is redrawn when the address changes, which takes the pressed link
  // with it: the focus goes to the top of the new page, where the bar is.
  const toMain = () => window.setTimeout(() => document.getElementById('main')?.focus(), 0)
  if (!here) return null
  const noun = (kind: string) => TASK_NOUN[kind as keyof typeof TASK_NOUN] ?? 'Task'

  return (
    <nav className="wq-bar" aria-label="My work queue">
      <span className="wq-where">
        From <a href={here.from}>My work</a>: <b>{here.at + 1}</b> of {here.of}
      </span>
      <span className="wq-steps">
        {here.prev ? (
          <a
            className="button ghost"
            href={here.prev.href}
            onClick={() => {
              moveQueue(here.at - 1)
              toMain()
            }}
            aria-label={'Previous: ' + here.prev.title}
          >
            Previous
          </a>
        ) : (
          <span className="wq-edge">First</span>
        )}
        {here.next ? (
          <a
            className="button"
            href={here.next.href}
            onClick={() => {
              moveQueue(here.at + 1)
              toMain()
            }}
          >
            Next: {here.next.title}
            <span className="wq-kind">{noun(here.next.kind)}</span>
          </a>
        ) : (
          <a className="button" href={here.from}>
            Last one: back to My work
          </a>
        )}
        <button
          type="button"
          className="ghost wq-close"
          aria-label="Stop: stop stepping through My work"
          title="Stop stepping through My work"
          onClick={() => {
            endQueue()
            setEnded((n) => n + 1)
            toMain()
          }}
        >
          Stop
        </button>
      </span>
    </nav>
  )
}
